export default function randomArrayElement(array) {
  return array[Math.floor(Math.random() * array.length)];
}
